export default __webpack_public_path__ + "static/media/height-icon.7f3cca5d.svg";